import { apiAuth } from "./base";

export function getCampaigns(params) {
  let api = apiAuth();
  return api.get('v1/campaigns', { params });
}

export function getCampaignDetail(campaign_id) {
  let api = apiAuth();
  return api.get(`v1/campaigns/${campaign_id}`);
}

export function getCampaignVouchers(campaign_id, params) {
  let api = apiAuth();
  return api.get(`v1/campaigns/${campaign_id}/vouchers`, { params });
}

export function downloadCampaignVouchers(campaign_id, params) {
  let api = apiAuth();
  return api.get(`v1/campaigns/${campaign_id}/vouchers/export/xlsx`, { params, responseType: 'blob' });
}